module.exports = __webpack_public_path__ + "static/Apercu-Medium-8d92ffe651f6b3f22eb2106ed4f92e87.woff";